import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

import { RenderableDynamicValues } from '../../../../../services/dictionary/types';
import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import type { Message } from '../../../../../store/slices/chat/types';
import { JoinDelimiter } from '../../../../../store/slices/chat/types';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';

import styles from './MessageContentConnected.module.css';

export interface MessageContentConnectedProps extends Pick<Message, 'content' | 'requireTranslation'> {
  dynamicValues?: RenderableDynamicValues;
  joinWith?: JoinDelimiter;
}

export const MessageContentConnected: FunctionComponent<MessageContentConnectedProps> = ({
  content,
  requireTranslation,
  dynamicValues,
  joinWith = JoinDelimiter.Space,
}) => {
  const messageContentMods = useModifiers(styles, 'messageContent', {
    newLine: joinWith === JoinDelimiter.NewLine,
  });

  if (!requireTranslation) {
    return content;
  }

  const messageKeys = content.split(JoinDelimiter.Space);

  return (
    <span className={messageContentMods}>
      {messageKeys.map((key, index) => (
        <Fragment key={key}>
          {index !== 0 ? joinWith : ''}
          <L10nText tk={key} dynamicValues={dynamicValues} />
        </Fragment>
      ))}
    </span>
  );
};
